var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container"},[_c('Header'),_c('div',{staticStyle:{"height":"92px"}}),_c('router-view'),_c('Footer'),_c('el-backtop',{attrs:{"bottom":100,"visibility-height":50}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }